"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  x0: 0,
  x025: 1,
  x05: 2,
  x1: 4,
  x2: 8,
  x3: 12,
  x4: 16,
  x5: 20,
  x6: 24,
  x8: 32,
  x10: 40,
  x12: 48,
  x15: 60,
  x20: 80,
  sizeBase: 4,
  sizeGrid: 20,
  fontSize1: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize2: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize3: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize4: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize5: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize6: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize7: {
    fontSize: 32,
    lineHeight: "40px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize8: {
    fontSize: 44,
    lineHeight: "52px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  toneValueX1: 0.04,
  toneValueX2: 0.08,
  toneValueX3: 0.12,
  toneValueX4: 0.16,
  toneValueX6: 0.24,
  toneValueX8: 0.32,
  toneValueX12: 0.48,
  toneValueX18: 0.72,
  toneValueOverlay: 0.48,
  toneValueBase: 0.48,
  toneValueViewer: 0.88,
  toneValueToolbar: 0.24,
  toneValueHover: 0.04,
  toneValueActive: 0.08,
  toneValueFocus: 0.08,
  depth0: "none",
  depth1: "0 2px 0 0 rgba(0, 16, 61, 0.04)",
  depth2: "0 4px 32px 0 rgba(0, 16, 61, 0.32)",
  depth3: "0 16px 48px 0 rgba(0, 0, 0, 0.48)",
  depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
  colorBorder: {
    normal: "rgba(0,0,0,0.12)",
    hover: "rgba(0,0,0,0.24)",
    active: "rgba(0,0,0,0.48)",
    focus: "rgba(0,0,0,0.24)"
  },
  colorDivider: {
    normal: "rgba(0,16,61,0.12)"
  },
  typeBorderButton: "solid",
  typeBorderPosition: "inset",
  colorBgToolbar: {
    normal: "#005ff9",
    hover: "#0056E2",
    active: "#004CCC"
  },
  colorBgSidebar: {
    normal: "transparent",
    hover: "rgba(0, 16, 61, 0.04)",
    active: "rgba(0, 16, 61, 0.08)"
  },
  depthSidebar: "none",
  colorBgTint: "transparent",
  colorBgGradientTint: "transparent",
  animationDurationL: "0.4s",
  animationDurationM: "0.2s",
  animationDurationS: "0.1s",
  transitionEasingDefault: "cubic-bezier(0.3, 0.3, 0.5, 1)",
  paddingBase: 20,
  paddingPopupBase: 32,
  paddingPopupHeader: 24,
  layoutWidthDesktopS: 768,
  colorPrimary: {
    normal: "#005ff9",
    hover: "#005CF1",
    active: "#0059EA"
  },
  colorSecondary: {
    normal: "#ff9e00",
    hover: "#F59802",
    active: "#EB9305"
  },
  sizeBorderWidth: 1,
  sizeBorderWidthTab: 2,
  sizeBorderWidthBar: 4,
  sizeBorderWidthAccent: 8,
  sizeBorderWidthAccentSecondary: 4,
  sizeBorderRadius: 4,
  sizeBorderRadiusPaper: 12,
  fontWeight: 400,
  fontWeightBold: 700,
  fontFamily: "Helvetica, Arial, sans-serif",
  fontSize: 15,
  lineHeight: 20,
  fontH0: {
    fontSize: 32,
    lineHeight: "40px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 24
  },
  fontH1: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 20
  },
  fontH2: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 16
  },
  fontH3: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 12
  },
  fontH4: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 8
  },
  fontH5: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 8
  },
  fontH6: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 8
  },
  fontBody: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontParagraph: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 24
  },
  fontList: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontListItem: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontFootnote: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontLead: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontQuote: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontTableHeader: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontControl: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontControlLabel: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontTab: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontBadge: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    letterSpacing: "1px",
    textTransform: "uppercase"
  },
  fontDisclaimer: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  sizeControlHeight: 40,
  sizeControlButtonWidthMin: 104,
  sizeControlButtonLargeHeight: 48,
  sizeControlButtonLargeWidth: 48,
  sizeControlButtonSmallHeight: 32,
  sizeControlButtonSmallWidth: 104,
  sizeControlButtonIconWidth: 40,
  sizeControlButtonSliderHeight: 24,
  sizeControlButtonSliderWidth: 12,
  sizeControlButtonSliderWidthPointer: 16,
  sizeControlFieldWidthMin: 380,
  sizeControlLabelWidth: 184,
  sizeControlCheckHeight: 16,
  sizeControlCheckWidth: 16,
  sizeProgress: 4,
  sizeProgressScroll: 12,
  sizeDotBullet: 4,
  sizeDotIndicate: 8,
  sizeDotClickable: 12,
  sizeArrowHeight: 8,
  sizeArrowWidth: 12,
  sizePopupSmall: 420,
  sizePopupMedium: 680,
  sizePopupLarge: 880,
  paddingControlHorizontal: 12,
  paddingControlVertical: 0,
  paddingControlMore: 8,
  paddingControlMoreIcon: 8,
  paddingControlButton: 16,
  paddingControlButtonIcon: 20,
  paddingControlDiv: 4,
  paddingMenu: 8,
  paddingTag: 8,
  paddingTab: 16,
  paddingArrow: 12,
  paddingTableHorizontal: 16,
  paddingTableVertical: 16,
  paddingSliceTop: 40,
  paddingSliceBottom: 60,
  marginControl: 12,
  marginFormLabelHorizontal: 16,
  marginFormLabelVertical: 4,
  marginFormTip: 4,
  marginFormFieldHorizontal: 20,
  marginFormFieldVertical: 24,
  marginFormFieldSet: 32,
  marginIcon: 8,
  marginChoice: 8,
  marginMenu: 2,
  marginTooltip: 8,
  marginTag: 8,
  marginTab: 8,
  marginBullet: 12,
  marginAttribute: 4,
  marginPopup: 24,
  sizeIconUI: 18,
  sizeIconHeader: 20,
  sizeIconWysiwyg: 14,
  sizeIllustrationS: 48,
  sizeIllustrationXM: 72,
  sizeIllustrationM: 96,
  sizeIllustrationL: 144,
  sizeIllustrationXXL: 228,
  sizeAvatarXS: 24,
  sizeAvatarS: 32,
  sizeAvatarM: 48,
  sizeAvatarL: 96,
  sizeAvatarXL: 128,
  widthTouch: "(width < 768px)",
  widthDesktopS: "(width >= 768px)",
  widthFromDesktopS: "(width >= 768px)",
  widthToTouch: "(width < 768px)",
  colorStateHover: {
    normal: "rgba(0, 16, 61, 0.04)"
  },
  colorStateActive: {
    normal: "rgba(0, 16, 61, 0.08)"
  },
  colorOverlay: {
    normal: "rgba(0, 0, 0, 0.48)"
  },
  colorText: {
    normal: "#333333"
  },
  colorTextSecondary: {
    normal: "#999999"
  },
  colorTextContrast: {
    normal: "#ffffff"
  },
  colorIcon: {
    normal: "#333333"
  },
  colorIconContrast: {
    normal: "#ffffff"
  },
  colorLink: {
    normal: "#005bd1"
  },
  colorLinkVisited: {
    normal: "#528fdf"
  },
  colorLinkContrast: {
    normal: "#ffffff"
  },
  colorTrueBlack: {
    normal: "#000000"
  },
  colorTrueWhite: {
    normal: "#ffffff"
  },
  colorState: {
    normal: "#00103d"
  },
  colorAlert: {
    normal: "#c1341b"
  },
  colorBgHighlight: {
    normal: "#FFF1AD"
  },
  colorIconSecondary: {
    normal: "#c7c7c7",
    hover: "#BFC0C1",
    active: "#B7B8BC"
  },
  colorBg: {
    normal: "#ffffff",
    hover: "#F5F5F7",
    active: "#EBECEF"
  },
  colorBgPopup: {
    normal: "#ffffff",
    hover: "#F5F5F7",
    active: "#EBECEF"
  },
  colorBgSecondary: {
    normal: "#f0f0f0",
    hover: "#E6E7E9",
    active: "#DDDEE2"
  },
  colorBgContrast: {
    normal: "#333333",
    hover: "#313233",
    active: "#2F3034"
  },
  colorBgThumbnail: {
    normal: "rgba(0, 16, 61, 0.08)",
    hover: "rgba(0, 16, 61, 0.12)",
    active: "rgba(0, 16, 61, 0.16)"
  },
  colorSuccess: {
    normal: "#0DC268",
    hover: "#0CBB66",
    active: "#0CB465"
  },
  colorError: {
    normal: "#ED0A34",
    hover: "#E40A34",
    active: "#DA0A35"
  },
  colorWarning: {
    normal: "#fffce0",
    hover: "#F5F3D9",
    active: "#EBE9D3"
  },
  colorBgWarning: {
    normal: "#fffce0",
    hover: "#F5F3D9",
    active: "#EBE9D3"
  },
  colorRating: {
    normal: "#ffd400",
    hover: "#F5CC02",
    active: "#EBC405"
  },
  colorNotify: {
    normal: "#ff9e00",
    hover: "#F59802",
    active: "#EB9305"
  },
  colorSocialVk: {
    normal: "#4680C2",
    hover: "#437CBD",
    active: "#4077B7"
  },
  colorSocialOk: {
    normal: "#ee8208",
    hover: "#E47D0A",
    active: "#DB790C"
  },
  colorSocialMir: {
    normal: "#117eda",
    hover: "#107AD4",
    active: "#1075CD"
  },
  colorSocialFb: {
    normal: "#0561af",
    hover: "#055EAA",
    active: "#055BA6"
  },
  colorSocialTwitter: {
    normal: "#00bff3",
    hover: "#00B8EC",
    active: "#00B1E4"
  },
  colorSocialDribbble: {
    normal: "#ea4c89",
    hover: "#E14A86",
    active: "#D74783"
  },
  colorSocialBehance: {
    normal: "#0057ff",
    hover: "#0054F7",
    active: "#0051EF"
  },
  colorPaletteRed1: {
    normal: "#fc2c38",
    hover: "#F22B38",
    active: "#E82A38"
  },
  colorPaletteRed2: {
    normal: "#eb1981",
    hover: "#E2197E",
    active: "#D8187C"
  },
  colorPaletteRed3: {
    normal: "#ff71bb",
    hover: "#F56DB6",
    active: "#EB69B1"
  },
  colorPaletteOrange1: {
    normal: "#ff8b2e",
    hover: "#F5862F",
    active: "#EB812F"
  },
  colorPaletteOrange2: {
    normal: "rgba(255, 158, 0, 0.12)",
    hover: "rgba(255, 158, 0, 0.16)",
    active: "rgba(255, 158, 0, 0.2)"
  },
  colorPaletteYellow1: {
    normal: "#ffc311",
    hover: "#F5BC13",
    active: "#EBB515"
  },
  colorPaletteGreen1: {
    normal: "#aee113",
    hover: "#A7D915",
    active: "#A0D016"
  },
  colorPaletteGreen2: {
    normal: "#59c354",
    hover: "#55BC53",
    active: "#52B552"
  },
  colorPaletteGreen3: {
    normal: "#37eb94",
    hover: "#35E291",
    active: "#33D98D"
  },
  colorPaletteGreen4: {
    normal: "#00b1b3",
    hover: "#00ABAE",
    active: "#00A4AA"
  },
  colorPaletteGreen5: {
    normal: "rgba(92, 186, 56, 0.12)",
    hover: "rgba(92, 186, 56, 0.16)",
    active: "rgba(92, 186, 56, 0.2)"
  },
  colorPaletteGreen6: {
    normal: "rgba(0, 230, 180, 0.08)",
    hover: "rgba(0, 230, 180, 0.12)",
    active: "rgba(0, 230, 180, 0.16)"
  },
  colorPaletteBlue1: {
    normal: "#2951ff",
    hover: "#274EF7",
    active: "#264CEF"
  },
  colorPaletteBlue2: {
    normal: "#00abf2",
    hover: "#00A5EB",
    active: "#009FE4"
  },
  colorPaletteBlue3: {
    normal: "#26dfdf",
    hover: "#24D7D9",
    active: "#23CED2"
  },
  colorPaletteBlue4: {
    normal: "rgba(0, 95, 249, 0.12)",
    hover: "rgba(0, 95, 249, 0.16)",
    active: "rgba(0, 95, 249, 0.2)"
  },
  colorPaletteViolet1: {
    normal: "#6c00ff",
    hover: "#6801F7",
    active: "#6301EF"
  },
  colorPaletteViolet2: {
    normal: "#ae73ff",
    hover: "#A76FF7",
    active: "#A06BEF"
  },
  colorIconFavorite: {
    normal: "#fc2c38",
    hover: "#F22B38",
    active: "#E82A38"
  },
  colorIconUnread: {
    normal: "#005ff9",
    hover: "#005CF1",
    active: "#0059EA"
  },
  colorBgPlaceholder: {
    normal: "#ffffff"
  },
  colorTextSidebar: {
    normal: "#333333"
  },
  colorIconSidebar: {
    normal: "#333333"
  },
  colorBorderSidebar: {
    normal: "rgba(0,0,0,0.12)"
  },
  colorScrollbar: {
    normal: "rgba(0, 16, 61, 0.48)"
  },
  colorBgSecondaryFlat: {
    normal: "#f0f0f0",
    hover: "#E6E7E9",
    active: "#DDDEE2"
  },
  colorCategoryMailings: {
    normal: "#FC8A15",
    hover: "#F28517",
    active: "#E88018"
  },
  colorCategorySocial: {
    normal: "#4F6DDC",
    hover: "#4C69D6",
    active: "#4966CF"
  },
  colorCategoryShopping: {
    normal: "#FF54AA",
    hover: "#F551A6",
    active: "#EB4FA1"
  },
  colorCategoryRegistrations: {
    normal: "#FF9E02",
    hover: "#F59804",
    active: "#EB9307"
  },
  colorCategoryFinance: {
    normal: "#07BB3F",
    hover: "#07B43F",
    active: "#06AD3F"
  },
  colorCategoryTicket: {
    normal: "#09A6FA",
    hover: "#09A0F2",
    active: "#089AEB"
  },
  colorCategoryTravel: {
    normal: "#BA34FC",
    hover: "#B333F4",
    active: "#AB31ED"
  },
  colorCategoryFees: {
    normal: "#E60000",
    hover: "#DD0102",
    active: "#D40105"
  }
};
exports.default = theme;